/*
 * Copyright (c) 2008-present Sonatype, Inc.
 *
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/pro/attributions
 * Sonatype and Sonatype Nexus are trademarks of Sonatype, Inc. Apache Maven is a trademark of the Apache Foundation.
 * M2Eclipse is a trademark of the Eclipse Foundation. All other trademarks are the property of their respective owners.
 */
import React from 'react';
import { LoginPage } from '@sonatype/nexus-ui-plugin';

import proLogo from "../../../../art/logos/logo-pro-edition-header.svg";
import proDarkLogo from "../../../../art/logos/logo-pro-edition-header-dark.svg";

const logoConfig = {
  proLight: proLogo,
  proDark: proDarkLogo
};

/**
 * Cloud UI login page wrapper with pro edition logos configured.
 */
export default function CloudUILoginPageWrapper() {
  return <LoginPage logoConfig={logoConfig} />;
}
